import {
  getParamValueByName, redirectToLogin
} from '../Shared/common';
import './movies.css';
import './search-movies.css';


const watchedFailure = (result) => {
  var parser = document.createElement('a');
  parser.href = result.getResponseHeader('location');
  var search = getParamValueByName('ReturnUrl', parser.search);
  var anchor = getParamValueByName('MovieId', search);
  if (result.status === 401)
    redirectToLogin(anchor);
};

//const movieWatched = (res, status) => {
//  if (status == "success") {
//    var el = document.createElement("div");
//    el.innerHTML = res;

//    var url = $('a.movie-watched', el).attr("data-ajax-url");
//    var movieId = getParamValueByName('MovieId', url);
//    var watched = getParamValueByName('Watched', url)
//    watched = watched == 'true' || !watched ? false : true;
//    var updateUrl = '/TvShows/UpdateTvShowWatched?MovieId=' + movieId + '&Watched=' + watched;

//    $.ajax({
//      url: updateUrl,
//      type: "GET",
//      dataType: "html",
//      cache: false,
//      success: function (data) {
//        $('#schedule').html(data);
//      }
//    });
//  }
//}

const updateTvShowWatchedSuccess = (res, status) => {
  if (status == "success") {
    var el = document.createElement("div");
    el.innerHTML = res;

    var url = $('a', el).attr("data-ajax-url");
    var movieId = getParamValueByName('MovieId', url);
    var elMovieId = '#movie_' + movieId;

    $.ajax({
      url: '/Movies/GetWatchedFavoriteMovieIcons?MovieId=' + movieId,
      type: "GET",
      dataType: "html",
      cache: false,
      success: function (data) {
        $(elMovieId).html(data);
      }
    });
  }
}

const showHideFilter = () => {
  var filters = document.getElementById("filters");
  var btnFilter = document.getElementById("btn-filter");

  filters.classList.toggle("filters-hide");
  var i = btnFilter.querySelector("i");
  i.classList.toggle("fa-angle-down");
  i.classList.toggle("fa-angle-up");
}

const btnFilterClick = () => {
  showHideFilter();

  //var filters = document.getElementById("filters");
  //if (filters.classList.contains("filters-hide")) {
  //  localStorage.setItem('filter-opened', false);
  //} else {
  //  localStorage.setItem('filter-opened', true);
  //}
};

//const showFilters = () => {
//  if (localStorage.getItem('filter-opened') === "false") {
//    showHideFilter();
//  }
//}

//showFilters();

window.watchedFailure = watchedFailure;
window.updateTvShowWatchedSuccess = updateTvShowWatchedSuccess;
window.btnFilterClick = btnFilterClick;